'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import { ArrowRightIcon } from '@heroicons/react/20/solid'

const FounderExcellenceSection = () => {
  return (
    <div className="relative">
      <div className="relative pt-24 max-w-7xl w-full mx-auto px-6 lg:px-8">
        <FadeInStagger faster>
          <div className="max-w-full  flex-col  gap-12 flex">
            <div className="flex-col sm:flex-row items-start justify-between gap-5 flex">
              <div className=" flex-col  gap-3 flex">
                <FadeIn>
                  <div className="p-1 w-auto bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 inline-flex">
                    <div className="px-2.5 py-0.5 bg-white bg-opacity-10 rounded-2xl justify-start items-center flex">
                      <div className="text-center text-white text-sm font-medium  leading-5">
                        What We Do
                      </div>
                    </div>
                  </div>
                </FadeIn>

                <FadeIn>
                  <h2 className="text-left text-white text-[36px] font-semibold leading-[44px]">
                    Uncompromising Excellence
                  </h2>
                </FadeIn>
              </div>
              <FadeIn className="flex justify-end">
                <p className="text-left text-[#D0D5DD] text-xl font-normal leading-[28px] w-auto sm:w-2/3">
                  We start with the belief in your personal potential as we’re
                  Founder-First. We then test that through a challenging, yet
                  supportive environment that pushes you to go beyond what's
                  comfortable and achieve truly outstanding results. We're here
                  to help you unlock your highest ambitions because we know that
                  greatness comes from pushing boundaries.
                </p>
              </FadeIn>
            </div>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-2 gap-[16px] pt-16">
            <FadeIn class="relative h-[488px] col-start-1 sm:row-start-1 sm:row-span-3 md:col-start-1  col-span-2 sm:col-span-1  rounded-[16px] border border-[#D6D6D6] overflow-hidden ">
              <img
                className="w-full h-full object-cover"
                src={'/images/home/pi-12.webp'}
              />
            </FadeIn>
            <FadeIn class="h-[488px] sm:col-start-2 row-start-3 sm:row-span-3 md:row-start-3 col-span-2 sm:col-span-1  rounded-[16px] border border-[#D6D6D6] overflow-hidden ">
              <img
                className="w-full h-full object-cover"
                src={'/images/home/f-2.webp'}
              />
            </FadeIn>
            <FadeIn class="h-[366px] col-start-1 row-start-4 sm:row-span-2 md:col-start-1 md:row-start-4 col-span-2 sm:col-span-1  rounded-[16px] border border-[#D6D6D6] overflow-hidden ">
              <img
                className="w-full h-full object-cover"
                src={'/images/home/f-3.webp'}
              />
            </FadeIn>
            <FadeIn class="bg-[#000000] py-[20px] h-auto sm:h-[374px] sm:col-start-2 sm:row-start-1 sm:row-span-2 col-span-2 sm:col-span-1  rounded-[16px] border border-[#424242] overflow-hidden ">
              <div className="mx-[20px]  p-1 w-auto bg-white bg-opacity-10 rounded-2xl border border-neutral-700 justify-start items-center gap-3 inline-flex">
                <div className="px-2.5 py-0.5 rounded-2xl justify-start items-center flex">
                  <div className="flex gap-2 items-center justify-center text-white text-sm font-medium  leading-5">
                    Founder Strength <ArrowRightIcon className="w-4 h-4" />
                  </div>
                </div>
              </div>

              <div className="text-[30px] text-white font-[600] px-[20px] ">
                Forging Resilient Leaders
              </div>
              <div className="text-lg text-[#98A2B3] px-[20px]">
                Starting a company isn't easy - we get that. That's why we're
                committed to helping you become not just a successful founder
                but a resilient leader ready to make waves in the AI industry.
                We'll challenge you, provide tough love but at the same time,
                support you, and get our hands dirty in helping you create your
                company alongside you to transform your vision into reality.
              </div>
            </FadeIn>
          </div>
        </FadeInStagger>
      </div>
    </div>
  )
}
export default FounderExcellenceSection
